import LoopWins from "slotworks/state-machine/standard/states/loop-wins";
import HarleyComponents from "components/components";
import { StartBaseMusic, StartBaseMusicSoft } from "commands/music";
import gameState from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export default class HarleyLoopWins extends LoopWins {

    public onEnter() {
        HarleyComponents.bonusBuyButton.setEnabled(true);
        if (gameState.currentGameHasSymbolWinResults()) {
            const record = gameState.getCurrentGame().getCurrentRecord() as SpinRecord;

            if(record.timesCycled === 0) {
                StartBaseMusicSoft();
            }
        }
        super.onEnter();
    }

    public onExit() {
        StartBaseMusic();
        super.onExit();
    }

}